// extracted by mini-css-extract-plugin
export var danger = "_3v-6";
export var lightPink = "_3v-a";
export var medium = "_3v-j";
export var nearSquare = "_3v-m";
export var neutralBlue = "_3v-8";
export var neutralYellow = "_3v-7";
export var noCapitalize = "_3v-1";
export var normal = "_3v-2";
export var pill = "_3v-0";
export var primary = "_3v-3";
export var primaryLight = "_3v-4";
export var shadow = "_3v-n";
export var small = "_3v-k";
export var solidBlack = "_3v-i";
export var solidGreen = "_3v-d";
export var solidLightBlue = "_3v-f";
export var solidNavy = "_3v-e";
export var solidOrange = "_3v-h";
export var solidPink = "_3v-g";
export var solidRed = "_3v-b";
export var solidWhite = "_3v-9";
export var solidYellow = "_3v-c";
export var success = "_3v-5";
export var xsmall = "_3v-l";